// libs
import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import "../../assets/css/form.css";
import "react-datepicker/dist/react-datepicker.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from "../../config/index";

function PincodeFormModal({urlaccountid, shippingpriceRowId, pincodeRowId, editPincode, setshowpincodeformmodal, refreshdata, token}) {

    const [InputFields, setInputFields] = useState({
        pincode: editPincode || ""
    });
    const isEditMode = !!pincodeRowId;
    const btnLabel = isEditMode ? 'UPDATE RECORD' : 'SAVE RECORD';
    const [SubmitButton, setSubmitButton] = useState(btnLabel);
    const [DisableSubmitButton, setDisableSubmitButton] = useState(false);
    const [Show, setShow] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();
    
    const hideModal = () => {
        setShow(false);
        setshowpincodeformmodal(false)
	}

    const onSubmit = async (data) => {
        setSubmitButton('LOADING...');
        setDisableSubmitButton(true);
        let apiCall = "";
        if(isEditMode) {
            let postData = {
                accountId: urlaccountid,
                rowId: pincodeRowId,
                shippingPriceId: shippingpriceRowId || 0,
                pincode: data.pincode
            }
            apiCall = await ajaxCall.patchCall(`${config.api.generic}/shipping-price/pincodes`, postData, token);
        } else {
            let postData = {
                accountId: urlaccountid,
                shippingPriceId: shippingpriceRowId || 0,
                pincode: data.pincode
            }
            apiCall = await ajaxCall.postCall(`${config.api.generic}/shipping-price/pincodes`, postData, token);
        }
        if(apiCall && apiCall.status) {
            setSubmitButton(btnLabel);
            toast.info('Record updated successfully');
            reset();
            setDisableSubmitButton(false);
            if(refreshdata) refreshdata();
        } else {
            setSubmitButton(btnLabel);
            toast.error(apiCall && apiCall.context && apiCall.context.message || 'Something went wrong. Please try again :(');
            setDisableSubmitButton(false);
        }
    }

    React.useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }
        loadComponent();
    }, []);

    return (
        <>
            <Modal show={Show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title>{isEditMode ? 'Update Shipping Pincode' : 'Add Shipping Pincode'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <form action="" method="" className="p-sm-1" onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    <Col md="12" className="mt-3">
                                        <label className="form-label fs-14rem fw-bold">Pincode</label>
                                        <input type="text" defaultValue={InputFields.pincode} className="form-control" {...register("pincode", { required: true, minLength: 1, maxLength: 6 })} />
                                        <small className="form-text text-danger">
                                            {errors.pincode?.type === "required" && "Pincode is mandatory"}
                                        </small>
                                        <small className="form-text text-danger">
                                            {errors.pincode?.type === "minLength" && "Enter atleast 1 characters"}
                                        </small>
                                        <small className="form-text text-danger">
                                            {errors.pincode?.type === "maxLength" && "Only 6 characters allowed"}
                                        </small>
                                    </Col>
                                    <Col md="12" className="text-end">
                                        <Button variant="primary" type="submit" disabled={DisableSubmitButton} className="vt-primary-btn border-0 text-end text-white mt-4 fs-14rem">{SubmitButton}</Button>
                                    </Col>
                                </Row>
                            </form>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}

export default PincodeFormModal;
